import request from "../services/HTTPClient";
import { requestMethods } from "../constants";

const ANALYTICS_BASE_URL = 'analitics';

const DashboardService = {
  getFinancialMetrics: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/sales`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },

  getOperationalMetrics: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/services-overview`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },

  getUserMetrics: () => {
    return request({
      url: `${ANALYTICS_BASE_URL}/users-overview`,
      method: requestMethods.GET,
    });
  },

  getSalesTrends: (params = {}) => {
    const { year } = params;
    let url = `${ANALYTICS_BASE_URL}/sales-by-category`;

    const queryParams = [];
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },

  getTopClients: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/top-clients`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },


  getTopClientsMXN: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/top-clients-mxn`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
   

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },
  getTopClientsUSD: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/top-clients-usd`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },

  getMarketplaceProducts: () => {
    return request({
      url: `${ANALYTICS_BASE_URL}/products-marketplace`,
      method: requestMethods.GET,
    });
  },

  getAllDashboardData: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    const commonParams = {};
    if (start_date) commonParams.start_date = start_date;
    if (end_date) commonParams.end_date = end_date;
    if (month) commonParams.month = month;
    if (year) commonParams.year = year;

    return Promise.all([
      DashboardService.getFinancialMetrics(commonParams),
      DashboardService.getOperationalMetrics(commonParams),
      DashboardService.getUserMetrics(),
      DashboardService.getSalesTrends({ year: year || new Date().getFullYear() }),
      DashboardService.getTopClients(commonParams),
      DashboardService.getTopClientsMXN(commonParams),
      DashboardService.getTopClientsUSD(commonParams),
      DashboardService.getMarketplaceProducts()
    ]).then(([
      financialRes,
      operationalRes,
      usersRes,
      trendsRes,
      topClientsRes,
      topClientsMXNRes,
      topClientsUSDRes,
      marketplaceProductsRes
    ]) => {
      return {
        success: true,
        timestamp: new Date().toISOString(),
        data: {
          sales: financialRes?.data?.data || {
            total_sales: financialRes?.data?.total_sales || 0,
            total_sales_mxn: financialRes?.data?.total_sales_mxn || 0,
            total_sales_usd: financialRes?.data?.total_sales_usd || 0,
            total_orders: financialRes?.data?.total_orders || 0,
            total_clients: financialRes?.data?.total_clients || 0,
            sales_by_category: financialRes?.data?.sales_by_category || [],
            date_range: financialRes?.data?.date_range || null,
            total_categories: financialRes?.data?.total_categories || 0
          },
          // Mapeo de servicios
          services: operationalRes?.data?.data || {
            services_by_status: operationalRes?.data?.services_by_status || [],
            services_by_category: operationalRes?.data?.services_by_category || [],
            date_range: operationalRes?.data?.date_range || null
          },
          // Mapeo de usuarios
          users: usersRes?.data?.data || {
            total_users: usersRes?.data?.total_users || 0,
            total_active_users: usersRes?.data?.total_active_users || 0,
            users_by_role: usersRes?.data?.users_by_role || [],
            active_users_by_role: usersRes?.data?.active_users_by_role || []
          },
          // Mapeo de tendencias
          trends: trendsRes?.data?.data || {
            year: trendsRes?.data?.year || new Date().getFullYear(),
            sales_by_month: trendsRes?.data?.sales_by_month || []
          },
          // Mapeo de top clientes
          topClients: topClientsRes?.data?.data || {
            top_clients: topClientsRes?.data?.top_clients || [],
            date_range: topClientsRes?.data?.date_range || null
          },
          topClientsMXN: topClientsMXNRes?.data?.data || {
            top_clients: topClientsMXNRes?.data?.top_clients || [],
            date_range: topClientsMXNRes?.data?.date_range || null
          },
          topClientsUSD: topClientsUSDRes?.data?.data || {
            top_clients: topClientsUSDRes?.data?.top_clients || [],
            date_range: topClientsUSDRes?.data?.date_range || null
          },
          marketplaceProducts: marketplaceProductsRes?.data || {
            total_products: marketplaceProductsRes?.data?.total_products || 0,
            products_by_category: marketplaceProductsRes?.data?.products_by_category || []
          },


        }
      };
    });
  },

  getSummary: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/sales`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },

  getOrderMetrics: (params = {}) => {
    return DashboardService.getOperationalMetrics(params);
  },

  getDashboardOverview: () => {
    return Promise.all([
      DashboardService.getFinancialMetrics(),
      DashboardService.getOperationalMetrics(),
      DashboardService.getUserMetrics()
    ]).then(([financialRes, operationalRes, usersRes]) => {
      return {
        success: true,
        timestamp: new Date().toISOString(),
        data: {
          financial: financialRes?.data?.data || financialRes?.data || {},
          operational: operationalRes?.data?.data || operationalRes?.data || {},
          users: usersRes?.data?.data || usersRes?.data || {}
        }
      };
    });
  },

  getMetricsByCategory: (category, params = {}) => {
    return DashboardService.getSalesTrends(params);
  },

  getQuickData: () => {
    return Promise.all([
      DashboardService.getFinancialMetrics(),
      DashboardService.getUserMetrics()
    ]).then(([financialRes, usersRes]) => {
      return {
        success: true,
        data: {
          financial: financialRes?.data?.data || financialRes?.data || {},
          users: usersRes?.data?.data || usersRes?.data || {}
        }
      };
    });
  },

  getRealtimeStats: () => {
    return Promise.all([
      DashboardService.getOperationalMetrics(),
      DashboardService.getUserMetrics()
    ]).then(([operationalRes, usersRes]) => {
      return {
        success: true,
        data: {
          operational: operationalRes?.data?.data || operationalRes?.data || {},
          users: usersRes?.data?.data || usersRes?.data || {}
        }
      };
    });
  },

  getOrdersAll: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/orders-all-detail`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },

  getClientsSalesDetail: (params = {}) => {
    const { start_date, end_date, month, year } = params;
    let url = `${ANALYTICS_BASE_URL}/clients-sales-detail`;

    const queryParams = [];
    if (start_date) queryParams.push(`start_date=${start_date}`);
    if (end_date) queryParams.push(`end_date=${end_date}`);
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return request({
      url: url,
      method: requestMethods.GET,
    });
  },


};

export default DashboardService;